import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function TermsOfServicePage() {
  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F6F1E8' }}>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12 md:py-20">
        {/* Back link */}
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm font-bold uppercase tracking-wider mb-8 hover:text-[#FF6B6B] transition-colors"
          data-testid="back-home-link"
        >
          <ArrowLeft className="w-4 h-4" strokeWidth={3} /> Back to Home
        </Link>

        <div className="bg-[#EDE3C7] border-[3px] border-[#121212] shadow-[6px_6px_0px_0px_#121212] rounded-2xl p-6 md:p-10">
          <h1
            className="text-3xl md:text-4xl font-black uppercase tracking-tighter mb-2"
            style={{ fontFamily: 'Outfit, sans-serif' }}
          >
            Terms of Service
          </h1>
          <p className="text-xs font-bold uppercase tracking-wider mb-8" style={{ color: '#888' }}>
            Last updated: April 12, 2026
          </p>

          <div className="space-y-6 text-sm font-medium leading-relaxed" style={{ color: '#444' }}>
            <section>
              <h2 className="text-lg font-black uppercase tracking-tight mb-2" style={{ fontFamily: 'Outfit, sans-serif', color: '#121212' }}>
                1. Acceptance of Terms
              </h2>
              <p>
                By accessing or using The SurfaceArea Project ("the Platform"), you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use the Platform.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-black uppercase tracking-tight mb-2" style={{ fontFamily: 'Outfit, sans-serif', color: '#121212' }}>
                2. Description of Service
              </h2>
              <p>
                The SurfaceArea Project is a marketplace where individuals ("Wearers") can offer to wear startup-branded T-shirts in exchange for compensation, and startups ("Startups") can browse and accept these offers. The Platform facilitates connections between Wearers and Startups but is not a party to any agreement between them.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-black uppercase tracking-tight mb-2" style={{ fontFamily: 'Outfit, sans-serif', color: '#121212' }}>
                3. Eligibility
              </h2>
              <p>
                To use the Platform as a Wearer, you must be a verified attendee of Y-Combinator Startup School India. Wearers must submit a valid acceptance screenshot for verification. Startups must register with a valid business identity.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-black uppercase tracking-tight mb-2" style={{ fontFamily: 'Outfit, sans-serif', color: '#121212' }}>
                4. User Accounts
              </h2>
              <p>
                You are responsible for maintaining the confidentiality of your account credentials. You agree to provide accurate and complete information during registration and to keep your account information up to date. You are responsible for all activities that occur under your account.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-black uppercase tracking-tight mb-2" style={{ fontFamily: 'Outfit, sans-serif', color: '#121212' }}>
                5. Marketplace Rules
              </h2>
              <ul className="list-disc pl-5 space-y-1">
                <li>Wearers set their own asking prices for wearing a T-shirt.</li>
                <li>Startups may accept asks at their discretion.</li>
                <li>Once an ask is accepted, both parties are expected to fulfill their obligations in good faith.</li>
                <li>The Platform reserves the right to remove any listing or user that violates these terms.</li>
                <li>All asking prices must be set in multiples of $10.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-black uppercase tracking-tight mb-2" style={{ fontFamily: 'Outfit, sans-serif', color: '#121212' }}>
                6. Payments & Fulfillment
              </h2>
              <p>
                Payment arrangements are handled directly between Wearers and Startups. The Platform does not process, hold, or guarantee any payments. The Platform is not responsible for disputes arising from payment or fulfillment issues between users.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-black uppercase tracking-tight mb-2" style={{ fontFamily: 'Outfit, sans-serif', color: '#121212' }}>
                7. Prohibited Conduct
              </h2>
              <ul className="list-disc pl-5 space-y-1">
                <li>Submitting false or misleading information during onboarding.</li>
                <li>Manipulating the marketplace through fraudulent asks or multiple accounts.</li>
                <li>Harassing, abusing, or threatening other users.</li>
                <li>Using the Platform for any illegal purpose.</li>
                <li>Attempting to reverse-engineer or interfere with the Platform's operation.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-black uppercase tracking-tight mb-2" style={{ fontFamily: 'Outfit, sans-serif', color: '#121212' }}>
                8. Intellectual Property
              </h2>
              <p>
                All content, branding, and design elements of The SurfaceArea Project are the property of its creators. Users retain ownership of their own submitted content but grant the Platform a non-exclusive license to display it as needed for the service.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-black uppercase tracking-tight mb-2" style={{ fontFamily: 'Outfit, sans-serif', color: '#121212' }}>
                9. Limitation of Liability
              </h2>
              <p>
                The Platform is provided "as is" without warranties of any kind. We are not liable for any indirect, incidental, or consequential damages arising from your use of the Platform. Our total liability shall not exceed the amount you have paid to us, if any.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-black uppercase tracking-tight mb-2" style={{ fontFamily: 'Outfit, sans-serif', color: '#121212' }}>
                10. Termination
              </h2>
              <p>
                We reserve the right to suspend or terminate your account at any time, with or without notice, for conduct that we determine violates these Terms or is harmful to other users, the Platform, or third parties.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-black uppercase tracking-tight mb-2" style={{ fontFamily: 'Outfit, sans-serif', color: '#121212' }}>
                11. Changes to Terms
              </h2>
              <p>
                We may update these Terms from time to time. Continued use of the Platform after any changes constitutes your acceptance of the revised Terms.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-black uppercase tracking-tight mb-2" style={{ fontFamily: 'Outfit, sans-serif', color: '#121212' }}>
                12. Contact
              </h2>
              <p>
                If you have questions about these Terms, please contact us at{' '}
                <a href="mailto:support@surfacearea.shop" className="font-bold underline hover:text-[#FF6B6B] transition-colors">
                  support@surfacearea.shop
                </a>.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
